const Data = {
  ru: 'Присоединяйтесь',
  en: 'Follow Us',
  ua: "Приєднуйтесь"

};

export default Data;
